import React from 'react';

function SvgEchIconSocialMediaYoutube2White(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
      <defs>
        <style>{'.cls-1{fill:#fff;}'}</style>
      </defs>
      <path
        className="cls-1"
        d="M61.57,35.57H38.43a9,9,0,0,0-9,9V55.38a9,9,0,0,0,9,9.05H61.57a9,9,0,0,0,9-9.05V44.62A9,9,0,0,0,61.57,35.57ZM43.89,57.05V43L58.3,50Z"
      />
    </svg>
  );
}
export default SvgEchIconSocialMediaYoutube2White;
